import type { ReactNode } from "react";
import { Box } from "../../Box";
import { Text } from "../../Text";
import type { SsoConfig } from "./constants";
import { MappingFields } from "./MappingFields";
import { MetadataImport } from "./MetadataImport";
import { SpDetails } from "./SpDetails";
import { Divider, DomainField, Field } from "./shared";

export function SamlFields({
  config,
  onConfigChange,
  existing,
  jitSection,
  mappingRelevant,
}: {
  config: SsoConfig;
  onConfigChange: (updater: (prev: SsoConfig) => SsoConfig) => void;
  existing?: boolean;
  jitSection: ReactNode;
  mappingRelevant: boolean;
}) {
  const isNew = !existing;

  return (
    <>
      <DomainField
        value={config.domain}
        onChange={(domain) => onConfigChange((f) => ({ ...f, domain }))}
        isNew={isNew}
      />

      <MetadataImport
        config={config}
        onConfigChange={onConfigChange}
        existing={existing}
      />

      <Divider />

      {jitSection}

      {mappingRelevant && (
        <>
          <Field>
            <Box horizontal={8}>
              <Text variant="text-small-md">Attribute mapping</Text>
              <Box top={4}>
                <Text variant="text-small" color="var(--text-secondary)">
                  Map SAML assertion attributes to user profile fields
                </Text>
              </Box>
            </Box>
          </Field>
          <MappingFields
            mapping={config.mapping}
            onChange={(mapping) => onConfigChange((f) => ({ ...f, mapping }))}
            placeholder={
              isNew ? "SAML attribute name" : "Leave blank to keep current"
            }
            allOptional={!isNew}
          />
        </>
      )}

      <Divider />
      <SpDetails providerId={config.providerId} isNew={isNew} />
    </>
  );
}
